"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountBalanceErrorState = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
var asg_1 = require("@alinta-digital/asg");
var Info_1 = require("@alinta-digital/asg/icons/components/Info");
var AccountBalanceErrorState = function () {
    var responsiveSize = (0, react_1.useContext)(asg_1.ResponsiveContext);
    return (react_1.default.createElement(asg_1.Box, { border: { size: '2px', color: asg_1.colors.brandOrange }, round: "8px", margin: {
            top: responsiveSize === 'xs' ? '5px' : undefined,
            bottom: 'xsmall',
        }, width: "100%", background: asg_1.colors.white, pad: {
            vertical: 'small',
            horizontal: responsiveSize === 'xs' ? 'medium' : 'small',
        }, "data-testid": "accountBalanceErrorStateContainer" },
        react_1.default.createElement(asg_1.Box, { margin: "auto", direction: "row" },
            react_1.default.createElement(asg_1.Icon, { "data-testid": "errorInfoIcon", id: "errorInfoIcon", icon: Info_1.Info, height: "24px !important", width: "24px !important" }),
            react_1.default.createElement(asg_1.Text, { margin: { left: '12px' } }, "Oops, something went wrong"))));
};
exports.AccountBalanceErrorState = AccountBalanceErrorState;
//# sourceMappingURL=AccountBalance.errorState.js.map